import React, { useState } from "react";
import CustomModal from "../../../../components/modal/CustomModal";
import { Flex } from "antd";
import { IconAlertSquareRounded } from "@tabler/icons-react";
import CustomTextarea from "../../../../components/input/CustomTextarea";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";

const RejectModal = ({ visible, onClose, complaintId, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const toast = useToast();

  const reset = () => setComment("");

  const handleCancel = () => {
    if (submitting) return;
    reset();
    onClose?.();
  };

  const handleOk = async () => {
    if (!complaintId || !comment) return;
    try {
      setSubmitting(true);
      const res = await api.reject_complaint(complaintId, { comment });
      if (res?.status === 200) {
        toast?.("Гомдлыг татгалзлаа.", "success");
        reset();
        onClose?.();
        onSuccess?.();
      } else {
        const msg =
          res?.data?.errors?.comment || res?.data?.message || "Алдаа гарлаа";
        toast?.(msg, "error");
      }
    } catch (e) {
      toast?.(e?.response?.data?.message || "Серверийн алдаа", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <CustomModal
      open={visible}
      title="Татгалзах"
      onCancel={handleCancel}
      onOk={handleOk}
      disabled={!comment || submitting}
    >
      <Flex vertical gap={10}>
        <Flex
          align="center"
          gap={10}
          style={{ backgroundColor: "#ffecec", padding: 15, borderRadius: 4 }}
        >
          <IconAlertSquareRounded
            strokeWidth={1.5}
            color="#5f5c73"
            style={{ width: 20, height: 20, flexShrink: 0 }}
          />
          <p style={{ color: "#5f5c73", textAlign: "justify", margin: 0 }}>
            Гомдлыг <b>“Татгалзсан”</b> төлөвт шилжүүлэх гэж байна. Шалтгаанаа
            тодорхой бичнэ үү.
          </p>
        </Flex>

        <CustomTextarea
          required
          title="Тайлбар / Шалтгаан"
          placeholder="Яагаад татгалзаж байгааг тайлбарлана уу…"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Flex>
    </CustomModal>
  );
};

export default RejectModal;
